// QuoteRequestFormComenTopBanner.jsx

import React from 'react';
//import Logo from '../images/PHOENIXSOLUTION-1.png';
import '../../styles/ComenTopBanner.scss';
import '../../styles/QuoteRequestForm/QuoteRequestFormComenTopBanner.scss';
import ArrowWhite from '../../images/Icon/btn-arrow-white.svg';

const QuoteRequestFormComenTopBanner = () => {
    const scrollToQuoteRequestForm = () => {
        const aboutSection = document.getElementById('quote-request-form-section');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      };
    return (
        <>
            <section className="Comen-top-banner QuoteRequestFormComenTopBanner">
                <div className="container">
                    <div className="Comen-top-banner-background"></div>
                </div>
                <div className="Comen-top-banner-cont">
                    <h1>REQUEST A QUOTE</h1>
                    <span className="cursive-font">Phoenix Solutions</span>
                </div>
                <div className="scroll-down-arrow" onClick={scrollToQuoteRequestForm}>
                    {/* &#x25BC; Downward arrow symbol */}
                    <i>
                        <img src={ArrowWhite} alt="btn-arrow-white" />
                    </i>
                </div>
            </section>
        </>
    );
};

export default QuoteRequestFormComenTopBanner;
